const typeMap = {
    IMAGES: {
        "image/*": [".jpg", ".jpeg", ".png", ".gif", ".webp", ".svg"]
    },
    DOCUMENTS: {
        "application/pdf": [".pdf"],
        "application/msword": [".doc"],
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
        "application/rtf": [".rtf"],
        "text/rtf": [".rtf"],
        "text/plain": [".txt"],
        "application/vnd.ms-excel": [".xls"],
        "application/excel": [".xls"],
        "application/x-msexcel": [".xls"],
        "application/x-excel": [".xls"],
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
        "application/vnd.ms-powerpoint": [".ppt"],
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": [".pptx"]
    }
};

export const acceptToTypeMapping = (accept) => {
    if (!accept || !Array.isArray(accept) || !accept.length) {
        return Object.keys(typeMap).reduce((acc, item) => ({ ...acc, ...typeMap[item] }), {});
    }

    return accept.reduce((acc, item) => {
        if (!Object.prototype.hasOwnProperty.call(typeMap, item)) {
            console.warn(`[FileSelector] Unknown accept type: ${item}`);
            return acc;
        }
        return {
            ...acc,
            ...typeMap[item]
        };
    }, {});
};
